import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchBranch } from '../../../external/AggregationApi';
import { actions } from '../../modules/Actions';

export const initialSearchBranchProbState: { [key: string]: SearchBranch } = {};

export const searchBranchProbReducer = reducerWithInitialState(initialSearchBranchProbState).case(
  actions.updateSearchBranch.prob,
  (state: { [key: string]: SearchBranch }, payload: { [key: string]: SearchBranch }) => {
    return {
      ...state,
      ...payload,
    };
  }
);
